// Think of MessageTypes as actions within a MessageGroup -> MessageArea
// eg. Contact -> InMails -> InMailSend

export enum  BidTypeEnum {
  Online,
  Hall,
  TakeOn
}
